var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgConnectPlus = function SvgConnectPlus(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "url(#paint0_linear_2979_45900)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.635 14.9904C15.02 14.1429 14.0375 13.5879 12.905 13.5879C11.0225 13.5879 9.49249 15.1179 9.49249 17.0004C9.49249 18.8829 11.0225 20.4129 12.905 20.4129C14.1725 20.4129 15.35 19.7454 16.0025 18.6579L17 17.0004L17.99 15.3429C18.6425 14.2554 19.82 13.5879 21.0875 13.5879C22.97 13.5879 24.5 15.1179 24.5 17.0004C24.5 18.8829 22.97 20.4129 21.0875 20.4129C19.9625 20.4129 18.98 19.8579 18.3575 19.0104",
    stroke: "url(#paint1_linear_2979_45900)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2979_45900",
    x1: 5,
    y1: 32,
    x2: 45,
    y2: 4.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D5AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#FF4081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2979_45900",
    x1: 9.00031,
    y1: 19,
    x2: 25.0003,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#536DFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4081"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgConnectPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "connect-plus.acb7ca36e92f8566d50b38cbe4acc31a.svg";